import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "ngx-dialog-title-prompt",
  templateUrl: "dialog-title-prompt.component.html",
  styleUrls: ["dialog-title-prompt.component.scss"],
})
export class DialogTitlePromptComponent implements OnInit {
  @Input() header: string;
  @Input() description?: string;
  @Input() title: string;
  @Input() status?: string;
  @Input() privacy?: boolean;
  @Input() mode?: string;

  diaForm: FormGroup;
  submitted = false;
  isPrivacy?: boolean;

  constructor(
    protected ref: NbDialogRef<DialogTitlePromptComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      status: Validators.required,
      privacy: Validators.required,
    });
    if (!this.status) {
      this.status = "0";
    }
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.submitted = true;
    const value = {
      title: this.title,
      status: this.status,
      privacy: this.privacy,
    };
    this.ref.close(value);
  }
}
